import { ProjectManifest, NodeStatus, IntentHistoryEntry } from '../../../../types/artifactory';

export interface BlueprintCardSummary {
  manifestId: string;
  name: string;
  nodeCount: number;
  freshCount: number;
  staleCount: number;
  ghostCount: number;
  files: string[];   // SP-3c Slice B — sorted non-ghost (materialized) manifest paths
  currentIntent: string;
  changelog: IntentHistoryEntry[];   // newest-first
  // SP2b — genesis lifecycle (read off manifest.metadata; mirrors blueprint_status).
  germinating: boolean;
  genesisFailed: boolean;
  genesisError: string | null;
  seedling: boolean;
  rootContext: string;
}

export function deriveBlueprintSummary(m: ProjectManifest): BlueprintCardSummary {
  const nodes = Object.values(m.nodes || {});
  const count = (s: NodeStatus) => nodes.filter((n) => n.status === s).length;
  const md = (m.metadata as any) || {};
  const name =
    md.project_name ||
    (m.root_context ? m.root_context.slice(0, 32) : m.id);
  const history = (m.intent_history || []).slice().reverse();
  return {
    manifestId: m.id,
    name,
    nodeCount: nodes.length,
    freshCount: count(NodeStatus.FRESH),
    staleCount: count(NodeStatus.STALE),
    ghostCount: count(NodeStatus.GHOST),
    files: nodes
      .filter((n) => n.status !== NodeStatus.GHOST)
      .map((n) => n.path)
      .sort(),
    currentIntent: m.root_context || '',
    changelog: history,
    germinating: !!md.germinating,
    genesisFailed: !!md.genesis_failed,
    genesisError: md.genesis_error ?? null,
    seedling: !!md.seedling,
    rootContext: m.root_context || '',
  };
}
